const initialState = {
  isAuthenticated: false,
  user: null,
  accessToken: null,
  idToken: null,
  expireBy: null,
  userEmail: null,
  loading: false,
  error: null
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'AUTH_LOGIN_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case 'AUTH_LOGIN_SUCCESS':
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        accessToken: action.payload.accessToken,
        idToken: action.payload.idToken,
        expireBy: action.payload.expireBy,
        userEmail: action.payload.userEmail,
        loading: false,
        error: null
      };
    
    case 'AUTH_LOGIN_FAILURE':
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        accessToken: null,
        idToken: null,
        expireBy: null,
        userEmail: null,
        loading: false,
        error: action.payload
      };
    
    case 'AUTH_LOGOUT':
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        accessToken: null,
        idToken: null,
        expireBy: null,
        userEmail: null,
        loading: false,
        error: null
      };
    
    case 'AUTH_CHECK_SESSION':
      return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
        user: action.payload.user,
        accessToken: action.payload.accessToken,
        idToken: action.payload.idToken,
        expireBy: action.payload.expireBy,
        userEmail: action.payload.userEmail,
        loading: false
      };
    
    default:
      return state;
  }
};

export default AuthReducer;
